import {useDocumentValidator} from "../../../../core/service/document.validator";

export const CNPJValidator = (_: any, value: any) =>
    useDocumentValidator().isValidCNPJ(value)
        ? Promise.resolve()
        : Promise.reject(new Error('O CNPJ informado não está válido'));
